import { render, staticRenderFns } from "./BusinessTaxReport.vue?vue&type=template&id=04db0851"
import script from "./BusinessTaxReport.vue?vue&type=script&lang=js"
export * from "./BusinessTaxReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports